
import React from 'react';
import './CSS/PolicyPage.css';

const Shipping = () => {
  return (
    <div className="policy-page container">
      <h1>Shipping Policy</h1>

      <div className="policy-section">
        <h2>1. Delivery Areas</h2>
        <p>We currently deliver within the specified campus/local areas only. Orders placed outside the delivery zone may not be processed. Please check our delivery availability before placing your order.</p>
      </div>

      <div className="policy-section">
        <h2>2. Delivery Time</h2>
        <p>Orders are typically delivered within 30–60 minutes, depending on order volume, weather conditions, and location. You will receive live order updates through our app or website once your order is confirmed.</p>
      </div>

      <div className="policy-section">
        <h2>3. Delivery Charges</h2>
        <p>Delivery charges, if applicable, are displayed at checkout before you confirm your order. These charges may vary based on distance, order size, or ongoing offers.</p>
      </div>

      <div className="policy-section">
        <h2>4. Delayed or Failed Delivery</h2>
        <p>In rare cases of delay due to unforeseen circumstances (such as traffic or weather), we will inform you promptly. If delivery cannot be completed due to incorrect address or unavailability, the order will be marked as completed and no refund will be processed.</p>
      </div>
    </div>
  );
};

export default Shipping;
